import { Label } from 'components/atoms';
import { useTranslation } from 'react-i18next';
import { PiArchive } from 'react-icons/pi';

const LabelNotificationArchived = () => {
  const { t } = useTranslation();

  return (
    <Label
      size='compact'
      color='black'
      title={t('notification.status.archived')}>
      <PiArchive /> {t('notification.status.archived')}
    </Label>
  );
};

export default LabelNotificationArchived;
